import React, { useRef } from 'react';
import GenericNotification from '../GenericNotification';
import { Icon } from 'src/components/Icons';
import { t } from 'i18next';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { Background } from '../../../Background';
import { MvpAppDesignModal } from '../../../Modals/components/ModalContainer/ModalContainer.styles';
import MvpAppSuccessMessage from '../../../Modals/Success/MvpAppSuccessMessage';

interface ISuccessNotification {
  text?: string | JSX.Element;
  Text?: JSX.Element;
  Icon?: JSX.Element;
  onClose?: () => void;
  onConfirm?: () => void;
  title: string;
}

const SuccessNotification = ({
  onClose,
  text,
  onConfirm,
  title,
  ...notificationProps
}: ISuccessNotification) => {
  const isFromMvpApp = useUrlParameterCheck('/app');
  const modalRef = useRef<HTMLDivElement | null>(null);
  const ariaLabel = t('Ok');

  return isFromMvpApp ? (
    <Background tabIndex={0} color="dark">
      <MvpAppDesignModal
        aria-live={'assertive'}
        role="alertdialog"
        tabIndex={0}
        ref={modalRef}
        title={'Success'}
      >
        <MvpAppSuccessMessage
          title={title}
          onConfirm={onConfirm}
          onCancel={onClose}
        />
      </MvpAppDesignModal>
    </Background>
  ) : (
    <GenericNotification
      type={'Success'}
      Icon={<Icon type="ok" color="white" aria-label={ariaLabel} />}
      text={text}
      {...notificationProps}
    />
  );
};

export default SuccessNotification;
